<!--
 * @Author: yuka
 * @Date: 2019-08-03 16:25:26
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-04 16:02:36
 * @Description: 
 -->
<template>
  <div class="m-total-data-wrapper">
    <div class="list-item" v-for="(item, index) in dataList" :key="index">
      <h2 class="title">{{ item.year }}年月度运营报告</h2>
      <div class="month-data-list clearfix">
        <a
          :href="
            `https://jinrfe.jinr.com/JydReport/index.html#/report?years=${item.year}&month=${
              month.month < 10 ? `0${month.month}` : month.month
            }`
          "
          v-for="(month, index) in item.list"
          :key="`${item.year}-${index}`"
          class="data-item"
        >
          <img src="https://files.jinr.com/jinr-index/img/data-report.png" alt="" srcset="" />
          <p class="year">{{ item.year }}</p>
          <p class="month">第{{ month.month }}月份</p>
          <p class="text">运营报告</p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import dataList from './map.js';
export default {
  name: 'total-data',
  computed: {
    dataList() {
      return dataList;
    }
  }
};
</script>
<style lang="less" scoped>
.m-total-data-wrapper {
  .title {
    text-align: center;
    font-size: 0.3rem;
    padding: 0.2rem 0;
    color: #666;
  }
  .data-item {
    position: relative;
    width: 2.8rem;
    height: 1.52rem;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // height: 1.34rem;
    margin: 0 0.05rem;
    color: #fff;
    img {
      position: absolute;
      z-index: 0;
      width: 100%;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
    }
    .year {
      position: relative;
      width: 100%;
      z-index: 1;
      font-size: 0.26rem;
      font-weight: 600;
      text-align: center;
    }
    .month {
      position: relative;
      z-index: 1;
      padding: 0px 0.1rem;
      background: #fff;
      color: #247af1;
      border-radius: 0.1rem;
      font-size: 0.24rem;
      text-align: center;
    }
    .text {
      position: relative;
      z-index: 1;
      font-size: 0.26rem;
    }
  }
}
</style>
